import { DisplayGrid, GridsterConfig, GridType } from 'angular-gridster2';
import { Tab } from '@components/tabs/tab.interface';
import { BuildingAuthorityType } from '@app/shared/models/building-authority-type';
import { SecurityUtils } from '@app/shared/utils/security.utils';
import { ServiceLevelType } from '@app/shared/models/service-level-type';

export const DashboardGridOptions: GridsterConfig = {
  gridType: GridType.Fit,
  displayGrid: DisplayGrid.OnDragAndResize,
  pushItems: false,
  swap: false,
  draggable: {
    delayStart: 0,
    enabled: false,
    ignoreContent: false,
    dragHandleClass: 'drag-handler',
    dropOverItems: false
  },
  resizable: {
    enabled: false
  },
  disableScrollHorizontal: true,
  disableScrollVertical: true,
  maxCols: 8,
  maxRows: 8,
  minItemRows: 2
};

export const DashboardTabs: Tab[] = [
  {
    name: 'General',
    path: '/buildings/{buildingId}/dashboard/general',
    dataCy: 'dashboard-general-tab',
    isAuthorized: SecurityUtils.hasBuildingAuthority(BuildingAuthorityType.VIEW_DASHBOARD_INSIGHTS)
  },
  {
    name: 'Energy',
    path: '/buildings/{buildingId}/dashboard/energy',
    dataCy: 'dashboard-energy-tab',
    isAuthorized: SecurityUtils.hasBuildingAuthority(BuildingAuthorityType.VIEW_DASHBOARD_INSIGHTS)
  },
  {
    name: 'Occupancy',
    path: '/buildings/{buildingId}/dashboard/occupancy',
    dataCy: 'dashboard-occupancy-tab',
    isAuthorized: SecurityUtils.hasBuildingAuthority(BuildingAuthorityType.VIEW_DASHBOARD_INSIGHTS)
  },
  {
    name: 'Maintenance',
    path: '/buildings/{buildingId}/dashboard/maintenance',
    dataCy: 'dashboard-maintenance-tab',
    isAuthorized: SecurityUtils.hasBuildingAuthority(BuildingAuthorityType.VIEW_DASHBOARD_INSIGHTS)
  },
  {
    name: 'Metrics',
    path: '/buildings/{buildingId}/dashboard/metrics',
    dataCy: 'dashboard-metrics-tab',
    isAuthorized: SecurityUtils.hasBuildingAuthority(BuildingAuthorityType.VIEW_DASHBOARD_ANALYTICS)
  },
  {
    name: 'EPBD Report',
    path: '',
    externalUrl: '{lmsUrl}/buildings/{buildingId}/analytics/epbd',
    dataCy: 'dashboard-epbd-tab',
    isAuthorized: (user, building) =>
      (building?.serviceLevel === ServiceLevelType.SMART_INSIGHT ||
        building?.serviceLevel === ServiceLevelType.SMART_PLUS) &&
      SecurityUtils.hasBuildingAuthority(BuildingAuthorityType.VIEW_DASHBOARD_INSIGHTS)(user, building) &&
      SecurityUtils.hasBuildingAuthority(BuildingAuthorityType.ANALYTICS)(user, building)
  }
];
